export const QUOTE_PDF_COMPANY = {
  name: 'Pró Médico Ltda',
  cnpj: '47.269.734/0001-34'
}
